import { FfNgxLoadingScreenConfig } from '@fagforbundet/ngx-components';
import { environment } from '@environments/environment';

export const loadingScreenConfig: FfNgxLoadingScreenConfig = {
  debug: environment.debug.loadingScreen,
  showLoadingScreenOnNavigation: true,
};
